export default __webpack_public_path__ + "static/media/last-name.43019c48.svg";